import React from 'react';

import { productionApi as api } from 'api/production';
import { UploadCSVAndReviewComponent } from 'shared';

function CarouselUpload() {
    const columns = [
        { Header: 'Carousel ID', accessor: 'carouselID' },
        { Header: 'Rank', accessor: 'rank' },
        { Header: 'External SKU', accessor: 'externalSku' },
        { Header: 'Sellable Bundle ID', accessor: 'sellableBundleID' },
        { Header: 'Warnings', accessor: 'warnings' },
    ];

    const confirmUpload = async (key) => {
        const res = await api.confirmCarouselUpload(key);
        return res;
    };

    const uploadCarousels = async (formData) => {
        const res = await api.uploadCarousels(formData);
        return res;
    };

    const downloadTemplate = () => {
        const csvContent = 'data:text/csv;charset=utf-8,Carousel ID,Rank,External SKU,Sellable Bundle ID';
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'carousel_upload_template.csv');
        document.body.appendChild(link);

        link.click();
    };

    return (
        <div>
            <UploadCSVAndReviewComponent
                title="Upload Carousels"
                fileLabel="Item File"
                columns={columns}
                upload={uploadCarousels}
                confirm={confirmUpload}
                downloadTemplate={downloadTemplate}
            />
        </div>
    );
}

export { CarouselUpload };
